import { render } from "./ExamCorrectionDetail.vue?vue&type=template&id=454d75d7"
import script from "./ExamCorrectionDetail.vue?vue&type=script&lang=js"
export * from "./ExamCorrectionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__